// extracted by mini-css-extract-plugin
export default {"faq_title":"FaqTitle_faq_title__UcBKG","first_frame":"FaqTitle_first_frame__wgVn2","second_frame":"FaqTitle_second_frame__XL9O4"};